import { Box, Breadcrumbs, Typography, useTheme } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useEntityManagementViewModel } from '../hooks/useEntityManagementViewModel';

export const EntityManagementPageHeader = () => {
  const theme = useTheme();
  const { t } = useTranslation(['periverse']);
  const { pathname } = useLocation();
  const { entities } = useEntityManagementViewModel();

  const isHome =
    pathname === '/entity-management' ||
    pathname === '/entity-management/';

  const currentEntity = isHome
    ? null
    : entities.find(
        (e) => pathname === e.to || pathname.startsWith(`${e.to}/`)
      );

  return (
    <Box sx={{ px: { xs: '1rem', md: '1.5rem', lg: '3rem', xl: '3rem' } }}>
      <Typography component="h1" lineHeight={'22px'} fontWeight={500} fontSize={18}>
        {t('pages.entityManagement.title')}
      </Typography>
      <Box padding={2}>
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          {isHome ? (
            <Typography
              color={theme.palette.info.main}
              fontSize={'1rem'}
              fontWeight={500}
            >
              {t('navigation.home')} /
            </Typography>
          ) : (
            <Link
              to="/entity-management"
              style={{
                color: theme.palette.info.main,
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: 500,
              }}
            >
              {t('navigation.home')}
            </Link>
          )}
          {currentEntity && (
            <Typography color="text.primary" fontSize={'1rem'} fontWeight={500}>
              {t(currentEntity.labelKey)}
            </Typography>
          )}
        </Breadcrumbs>
      </Box>
    </Box>
  );
};
